// Field configuration for the Regulations Injector form.
//
// `id` MUST match the RegsExtractorFields C# property name — it is used both as
// the React key and as the key inside formDataValue.RINJ.extractorFields.textValues
// (the shared InputField/TextArea write there via updateData -> actionHandler).
//
// PascalCase ids are intentional: InputField phone-masks the lowercase ids
// "contact" and "sort", so "Contact" avoids that special-casing.

// The single location.field grouping all injector inputs write under.
export const EXTRACTOR_FIELD = "extractorFields";

// `inline: true` renders a field on the same row as the field before it
// (see RegsInjector.renderRows) — e.g. Meeting Date sits beside Comment Deadline.
export const EXTRACTOR_FIELDS = [
  // State is a searchable dropdown fed from /region/all (see RegsInjector).
  { id: "State", label: "State", control: "dropdown" },
  { id: "IssuedDate", label: "Issued Date", control: "input", inline: true, isDate: true },
  { id: "Type", label: "Type", control: "input" },
  { id: "HistoryAction", label: "History Action", control: "input", inline: true },
  { id: "Title", label: "Title", control: "input" },
  { id: "Summary", label: "Summary", control: "textarea" },
  { id: "CommentDeadline", label: "Comment Deadline", control: "input", isDate: true },
  { id: "MeetingDate", label: "Meeting Date", control: "input", inline: true, isDate: true },
  { id: "Citation", label: "Citation", control: "input" },
  { id: "Contact", label: "Contact", control: "textarea", rows: 3 },
];



// WEBPACK FOOTER //
// ./src/routes/RegsInjector/constants.js